import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'

import OrbitSession from '../../hooks/useCookies'

export default function OrderFailure() {
  return (
    <Box height='100vh'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          padding: '0px 24px'
        }}
      >
        <Box sx={{ width: '60%', textAlign: 'center', marginBottom: '48px' }}>
          <Typography variant='h4' sx={{ marginBottom: '48px' }}>
            Your payment has failed to go through.
          </Typography>
          {OrbitSession.get('__id') !== undefined ? (
            <Typography variant='h6'>
              Please return to homepage to make your order
            </Typography>
          ) : (
            <Typography variant='h6'>
              Please login to continue your order.
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '60%'
          }}
        >
          {OrbitSession.get('_id') !== undefined ? (
            <Button variant='filled' as={RouterLink} to='/app' width='100%'>
              Back to homepage
            </Button>
          ) : (
            <Button variant='filled' as={RouterLink} to='/login' width='100%'>
              Log in
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  )
}
